import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	stepOneWrapper: {
		display       : "flex",
		flex          : 1,
		flexDirection : "column",
		gap           : "1rem"
	}
} );